import ContractsCargoTaxiList, {
  ContractsCargoTaxiListCargoCompany,
  ContractsCargoTaxiListItem,
  ContractsCargoTaxiListTaxiCorporation,
} from "../../../../../common/services/contracts/cargo-taxi/list/contracts-cargo-taxi-list";
import BillingModel from "../../../../../common/types/billing-model";
import CargoCargoTaxiContractListing, {
  CargoCargoTaxiContractListingCargoCompany,
  CargoCargoTaxiContractListingItem,
  CargoCargoTaxiContractListingModel,
  CargoCargoTaxiContractListingTaxiCorporation,
} from "./types/cargo-cargo-taxi-contract-listing-item";

const createModel = (
  model: BillingModel,
): CargoCargoTaxiContractListingModel => {
  switch (model) {
    case BillingModel.AB:
      return CargoCargoTaxiContractListingModel.AB;
    case BillingModel.ABA:
      return CargoCargoTaxiContractListingModel.ABA;
    case BillingModel.OTHER:
      return CargoCargoTaxiContractListingModel.OTHER;
    case BillingModel.SABS:
      return CargoCargoTaxiContractListingModel.SABS;
  }
};

const createTaxiCorporation = (
  taxiCorporation: ContractsCargoTaxiListTaxiCorporation,
): CargoCargoTaxiContractListingTaxiCorporation => {
  return {
    companyName: taxiCorporation.companyName,
  };
};

const createCargoCompany = (
  cargoCompany: ContractsCargoTaxiListCargoCompany,
): CargoCargoTaxiContractListingCargoCompany => {
  return {
    companyName: cargoCompany.companyName,
  };
};

const createDataItem = (
  item: ContractsCargoTaxiListItem,
): CargoCargoTaxiContractListingItem => {
  return {
    allowChargeDuringRide: item.allowChargeDuringRide,
    allowChargeWhileApproaching: item.allowChargeWhileApproaching,
    allowChargeWhileReturning: item.allowChargeWhileReturning,
    cargoCompany: createCargoCompany(item.cargoCompany),
    discountLimit: item.discountLimit,
    distanceRate: item.distanceRate,
    haltingTimeAfterMinutes: item.haltingTimeAfterMinutes,
    haltingTimeRate: item.haltingTimeRate,
    id: item.id,
    model: createModel(item.model),
    publishingAllowed: item.publishingAllowed,
    taxiCorporation: createTaxiCorporation(item.taxiCorporation),
    validSince: item.validSince,
    validTo: item.validTo,
    isValid: item.isValid,
  };
};

const createData = (
  data: ContractsCargoTaxiListItem[],
): CargoCargoTaxiContractListingItem[] => {
  const items: CargoCargoTaxiContractListingItem[] = data.map(createDataItem);

  return items;
};

const create = (
  list: ContractsCargoTaxiList,
): CargoCargoTaxiContractListing => {
  return {
    data: createData(list.data),
    totalCount: list.totalCount,
  };
};

const cargoCargoTaxiContractListingItemFactory = {
  create,
};

export default cargoCargoTaxiContractListingItemFactory;
